import { keyExists } from '../../../../utils';
import Token from './Token';
import { tokens } from './Lookup';
// something@somthing.com //something@ //@something.com
const emailPattern = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$|@\w+([-.]\w+)+|\w+([-+.']\w+)*@/;
function isItAnEmail(x) {
    return new RegExp(emailPattern, 'i').test(x);
}
function isItAND(x) {
    return x.length === 3 && /and/i.test(x);
}
function isItOR(x) {
    return x.length === 2 && /or/i.test(x);
}
function isValidChar(x) {
    return /[a-zA-Z0-9-.,@_]/i.test(x);
}
function isItBoolean(x) {
    return /(true|false)/i.test(x);
}
function areTokensTheSame(t1, t2) {
    return t1.type === t2.type && t1.literal === t2.literal;
}
export class Lexer {
    input;
    // current position in input (points to current char)
    position;
    // current reading position in input (after current char)
    readPosition;
    // current char under examination
    ch;
    debug;
    fieldNames;
    tokens;
    constructor(fieldNames, input) {
        this.fieldNames = fieldNames;
        this.input = input;
        this.position = 0;
        this.readPosition = 0;
        this.ch = '';
        this.debug = false;
        this.tokens = [];
    }
    toggleDebug() {
        this.debug = !this.debug;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    log(...args) {
        if (!this.debug) {
            return;
        }
        // eslint-disable-next-line no-console
        console.log(...args);
    }
    readChar() {
        if (this.readPosition >= this.input.length) {
            this.ch = '';
        }
        else {
            this.ch = this.input[this.readPosition];
        }
        this.position = this.readPosition;
        this.readPosition += 1;
    }
    isNextCharADot() {
        return this.input[this.position] === this.input[this.readPosition];
    }
    readIdentifier(condition) {
        const start = this.position;
        while (condition(this.ch)) {
            this.readChar();
        }
        const identifier = this.input.slice(start, this.position);
        this.rollbackPosition();
        return identifier;
    }
    lookupToken(identifier) {
        this.log('lookupToken:', identifier);
        if (isItAnEmail(identifier)) {
            return new Token(tokens.STRING, identifier);
        }
        if (isItAND(identifier)) {
            return new Token(tokens.AND, tokens.AND);
        }
        if (isItOR(identifier)) {
            return new Token(tokens.OR, tokens.OR);
        }
        if (isItBoolean(identifier)) {
            return new Token(tokens.BOOLEAN, identifier);
        }
        const id = identifier.toLocaleLowerCase();
        if (keyExists(this.fieldNames, id)) {
            const key = this.fieldNames[id];
            this.log('new Token(key, identifier)', new Token(key, identifier));
            return new Token(key, identifier);
        }
        const parsed = parseFloat(identifier);
        if (Number.isNaN(parsed)) {
            return new Token(tokens.STRING, identifier);
        }
        return new Token(tokens.NUMBER, identifier);
    }
    rollbackPosition() {
        this.position -= 1;
        this.readPosition -= 1;
    }
    skipSpaces() {
        this.log(`skipSpaces: "${this.ch}"`);
        if (this.ch === ' ' && this.readPosition > this.input.length - 1) {
            this.log('reached empty char case');
            return;
        }
        if (this.ch !== ' ') {
            return;
        }
        this.readChar();
        this.skipSpaces();
    }
    isOutOfBoundaries() {
        return this.readPosition > this.input.length;
    }
    readString(endChar) {
        const start = this.readPosition;
        do {
            this.readChar();
            if (this.isOutOfBoundaries()) {
                break;
            }
        } while (this.ch !== endChar);
        return this.input.slice(start, this.position);
    }
    isEndOfString() {
        return this.readPosition >= this.input.length;
    }
    addToken(t) {
        const l = this.tokens.length;
        const lastToken = this.tokens[l - 1];
        if (l === 0 || !areTokensTheSame(lastToken, t)) {
            this.log('called push for token:', t);
            this.tokens.push(t);
        }
    }
    nextToken() {
        let t = null;
        this.readChar();
        this.skipSpaces();
        this.log('readChar:', this.ch);
        switch (this.ch) {
            case ' ': {
                t = new Token(tokens.SPACE, tokens.SPACE);
                break;
            }
            case '': {
                if (this.isEndOfString()) {
                    t = new Token(tokens.EOF, tokens.EOF);
                    this.rollbackPosition();
                    break;
                }
                break;
            }
            case `'`:
            case `"`: {
                this.log('found a string:', this.ch);
                const endChar = this.ch;
                t = this.lookupToken(this.readString(endChar));
                break;
            }
            case ':': {
                t = new Token(tokens.EQUALITY, this.ch);
                break;
            }
            case '>':
                t = new Token(tokens.GREATER, this.ch);
                break;
            case '<':
                t = new Token(tokens.SMALLER, this.ch);
                break;
            case '.': {
                if (this.isNextCharADot()) {
                    t = new Token(tokens.RANGE, tokens.RANGE);
                    break;
                }
                break;
            }
            default: {
                if (isValidChar(this.ch)) {
                    this.log('isValidChar', isValidChar(this.ch));
                    t = this.lookupToken(this.readIdentifier(isValidChar));
                }
            }
        }
        if (t === null) {
            t = new Token(tokens.ILLEGAL, this.ch);
        }
        this.log('Token to be added:', t);
        this.addToken(t);
        return t;
    }
}
